<ion-menu side="start" contentId="mainContent">
  <ion-header>
    <ion-toolbar class="custom-header" translucent>
      <ion-item lines="none" routerDirection="root" [routerLink]="['/profile']" (click)="toggleMenu()">
        <ion-title><b>{{menuData.user }} </b></ion-title>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-menu-toggle auto-hide="false" *ngFor="let menu of menuData.appPages">
        <ion-item routerDirection="root" [routerLink]="[menu.url]" [queryParams]="menu?.queryParams">
          <ion-label>
            {{ menu.title }}
          </ion-label>
        </ion-item>
      </ion-menu-toggle>
    </ion-list>
  </ion-content>
</ion-menu>
<div>
  <ion-header >
    <ion-toolbar class="custom-header">
      <ion-buttons slot="start">
        <ion-menu-button class="menu-button"></ion-menu-button>
      </ion-buttons>
      <!-- <ion-thumbnail slot="start">
        <ion-img src="../../../assets/logo.png"></ion-img>
      </ion-thumbnail> -->
      <!-- <ion-label class="ion-padding"><strong>Test Carrier Portal </strong></ion-label> -->
      <span class="app-name">
        <strong>Carrier</strong>
        <span>Portal</span>
      </span>
      <ion-button slot="end" fill='clear' large matTooltip="Help" color="dark" (click)="openHelpPopover()">
        <ion-icon name="help-circle-outline"></ion-icon>
      </ion-button>
      <ion-button slot="end" fill='clear' large matTooltip="Logout" (click)="logoutAlert()">
        <ion-icon name="power-outline"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-header>
</div>